module.exports = __webpack_public_path__ + "media/tr_tr_s2_Ergin.b48c9978.oga";